export type Coach = {
  name: string
  role: string
  /** Optional photo. When empty, an initials badge is shown. */
  avatar: string
}

/** Coaches shown in the hero avatar row (initials badges). */
export const coaches: Coach[] = [
  { name: 'Jason Miller', role: 'U10 Coach · Ohio, USA', avatar: '' },
  { name: 'Chris Anderson', role: 'U12 Coach · Michigan, USA', avatar: '' },
  { name: 'Sarah Thompson', role: 'U10 Girls Coach · Pennsylvania, USA', avatar: '' },
  { name: 'Lauren Davis', role: 'U10 Coach · New York, USA', avatar: '' },
  { name: 'Megan Scott', role: 'U10 Coach · Ontario, Canada', avatar: '' },
  { name: 'Ryan Cooper', role: 'U14 Coach · Maryland, USA', avatar: '' },
]

/** Badge colors for the initials avatars (product palette). */
export const avatarColors = ['bg-turf', 'bg-sky', 'bg-gold', 'bg-navy-line', 'bg-turf', 'bg-sky']
